import React from 'react'
import { Helmet } from 'react-helmet'
import routes from 'constants/router'
import { useFindMatchedRoutes } from 'utils/findMatchedRoutes'
import useResolvedPageTitle from 'components/Seo/useResolvedPageTitle'

const Seo = () => {
  const matchedRoutes = useFindMatchedRoutes(routes)
  const title = useResolvedPageTitle(matchedRoutes)

  return (
    <Helmet defer={false}>
      {title ? <title key={title}>{title}</title> : null}
    </Helmet>
  )
}

export default Seo
